export const SET_USER_PROFILE_PICTURE = 'SET_PROFILE_PICTURE';
export const SET_ADMIN_ID = 'SET_ADMIN_ID';
export const SET_AUTH_TOKEN = 'SET_AUTH_TOKEN';


export const setUserProfilePicture = profileImage => ({
    type: SET_USER_PROFILE_PICTURE,
    profileImage
});

export const setAdminId = iAdminId => ({
    type: SET_ADMIN_ID,
    iAdminId
});

export const setAuthToken = authToken => ({
    type: SET_AUTH_TOKEN,
    authToken
})

export default function UserProfile(state = {
    profileImage: '',
    iAdminId: '',
    authToken: ''
}, action) {
    switch (action.type) {
        case SET_USER_PROFILE_PICTURE:
            return {
                ...state,
                profileImage: action.profileImage
            };
        case SET_ADMIN_ID:
            return {
                ...state,
                iAdminId: action.iAdminId
            };
        case SET_AUTH_TOKEN:
            return {
                ...state,
                authToken: action.authToken
            };
        default:
            return state;
    }
}
